// import ZtServiceFactory from '../../services/zt';
import ZtServiceFactory from '../../../../services/json';

const $ztService = ZtServiceFactory.getDefaultInstance();

/**
 * 获取验证码
 * @param params
 * @returns {Promise<{session_id: "1FgDfGnYqhBqq8HfPpp27n1281halWQn7Eue11SI", request_id: "f95286331d81cb00b8192b96dec2364ce3554728"}>}
 */
const sendCodeAsync = params => {
  return $ztService.getPhoneCode({
    ...params
  });
};

/**
 * 预约
 * @param params
 * @returns {Promise<{session_id: "1FgDfGnYqhBqq8HfPpp27n1281halWQn7Eue11SI", request_id: "2adea4796261580907e068582b92958dc24fcb8f"}>}
 */
const submitAsync = params => {
  return $ztService.subscribe(params);
};

const Service = {
  sendCodeAsync,
  submitAsync,
  getEmailCode: $ztService.getEmailCode
};
export default Service;
